module.exports = __webpack_public_path__ + "src/assets/images/HERO-Logo-Lg.png?7eaf71f7981b5758fdae989850e863fa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HERO-Logo-Lg.png
// module id = 975
// module chunks = 1